var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BlockCondition } from "sb-resp-block-lib";
import { observable, action, observe, computed } from "mobx";
import { DateRangePeriod } from "../types";
import { config } from "../blocks/BettingHistory/config";
import { dateDifferenceCalculator } from "../helpers";
export class Parser {
    constructor(props) {
        this.cacheDataObserver = () => { };
        this.dateRange = { from: props.retriever.request.from, to: props.retriever.request.to };
        this.bets = [];
        this.data = { bets: this.bets, ResultsData: [], sportsData: [] };
        this.retriever = props.retriever;
    }
    activate() {
        this.cacheDataObserver = observe(this.retriever.cache.data, (change) => this.handleCacheUpdates(change));
        this.dateRange.to = new Date();
        this.dateRange.from = dateDifferenceCalculator(this.dateRange.to, DateRangePeriod.Last24Hours);
        this.processData(this.retriever.cache.data);
        return this.retriever.activate();
    }
    deactivate() {
        this.cacheDataObserver();
        this.retriever.deactivate();
        this.resetData();
    }
    resetData() {
        this.bets.length = 0;
    }
    updateDateRange(dateRange) {
        this.bets.length = 0;
        this.retriever.updateDateRange(dateRange);
        this.dateRange.from = this.retriever.request.from;
        this.dateRange.to = this.retriever.request.to;
        this.processData(this.retriever.cache.data);
    }
    loadMore() {
        this.retriever.loadMore();
    }
    get condition() {
        if (this.retriever.condition === BlockCondition.LOADING) {
            return this.bets.length === 0 ? BlockCondition.LOADING : BlockCondition.LOADED;
        }
        return this.retriever.condition;
    }
    get statistics() {
        return this.retriever.statistics;
    }
    handleCacheUpdates(change) {
        //TO DO handle add, remove
        this.processData(change.added);
    }
    processData(bets) {
        bets.filter(bet => this.isInDateRange(bet)).forEach(bet => this.bets.push(bet));
    }
    isInDateRange(bet) {
        if (this.dateRange.from && this.dateRange.to) {
            let date = new Date(bet.settlementDate);
            return this.dateRange.from.getTime() <= date.getTime() && this.dateRange.to.getTime() >= date.getTime();
        }
        return true;
    }
    get config() {
        return this.retriever.config;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], Parser.prototype, "data", void 0);
__decorate([
    observable.shallow,
    __metadata("design:type", Array)
], Parser.prototype, "bets", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "updateDateRange", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Parser.prototype, "loadMore", null);
__decorate([
    computed,
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [])
], Parser.prototype, "condition", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Parser.prototype, "statistics", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "handleCacheUpdates", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Parser.prototype, "processData", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Parser.prototype, "config", null);
//# sourceMappingURL=Parser.js.map